import * as React from 'react';
export const Bar = props => React.createElement("div", Object.assign({ style: {
        padding: 16,
    } }, props));
export const PageOne = () => React.createElement("div", null, "Page one");
export const PageTwo = () => React.createElement("div", null, "Page two");
export const PageThree = () => React.createElement("div", null, "Page three");



// WEBPACK FOOTER //
// ./docs/src/example-helpers.tsx